import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetlinedetaildetailReducer(state = initialState.budgetlinedetailContent, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETLINEDETAILCONTENT_SUCCESS:
      return action.budgetlinedetailContent;
    default:
      return state;
  }
}
